export const APPTYPE_UPDATE = 'appTypeUpdate';